/* Vuex store */
import Vue from 'vue';
import Vuex from 'vuex';

import { subscribePendingStoreActions } from './plugins';

// MODULES /////////////////////////////////////////////////////////////////////
import global from './modules/global';
import user from './modules/user';
import users from './modules/users';
import records from './modules/records';
import record from './modules/record';
import connections from './modules/connections';
import client from './modules/client';
import callback from './modules/callback';
import reports from './modules/reports';
import report from './modules/report';
import blacklist from './modules/blacklist';
import addressBook from './modules/addressBook';
import form from './modules/form';
import dashboard from './modules/dashboard';
import sms from './modules/sms';
import campaigns from './modules/campaigns';
import campaign from './modules/campaign';
import callPlanner from './modules/callPlanner';
import promotions from './modules/promotions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    user,
    users,
    record,
    records,
    connections,
    client,
    callback,
    reports,
    report,
    blacklist,
    addressBook,
    form,
    dashboard,
    sms,
    campaigns,
    campaign,
    callPlanner,
    promotions
  },
  plugins: [subscribePendingStoreActions],
  strict: !process.env.DEBUG_MODE,
});
